// ChangeTicketStatus.js (Modified for tickets)
import React, { useEffect, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import InputTicketSearch from '../../includes/ui/InputTicketSearch';
import TapIcon from '../../../services/TapIcon';
import TicketMiniDetail from '../../includes/ui/TicketMiniDetail';
import HttpAPICall from '../../../services/HttpAPICall';
import { useSelector } from 'react-redux';
import Loader from '../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';
import GroupCard from '../../group/GroupCard';
import TapSelect from "../../../components/ui/TapSelect";
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const ChangeTicketStatus = ({ history }) => {
    const access_token = useSelector(state => state.auth.access_token);
    const location = useLocation();
    const selectedGroup = location.state?.selectedGroup;

    const [selectedTicket, setSelectedTicket] = useState(null);
    const [ticketDetails, setTicketDetails] = useState(null);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [statusOptions, setStatusOptions] = useState([]);
    const [newStatus, setNewStatus] = useState(null);
    const [statusLoading, setStatusLoading] = useState(false);
    const [saveFormSubmitting, setSaveFormSubmitting] = useState(false);

    const handleStatusChange = (selectedOption) => {
        setNewStatus(selectedOption);
    };

    const fetchFormData = () => {
        setStatusLoading(true);

        HttpAPICall.withAthorization(
            "GET",
            process.env.REACT_APP_SERVER_PATH + "/backoffice/ticket/form_data", 
            access_token, 
            {}, 
            {},
            (resp) => {
                const statusList =
                    (resp?.data?.status || []).map(item => ({
                        label: item.name,
                        value: item.key
                    }));

                setStatusOptions(statusList);
                setStatusLoading(false);
            },
            (error) => {
                toast.error(error, {
                    position: toast.POSITION.TOP_CENTER
                });
                setStatusLoading(false);
            }
        );
    };

    const fetchTicketDetails = (ticketId) => {
        setLoadingDetails(true);
        const url = process.env.REACT_APP_SERVER_PATH + `/backoffice/ticket/detail/${ticketId}`;

        const params = {
            master_id: selectedGroup?.master_id
        };

        HttpAPICall.withAthorization('GET', url, access_token, params, {},
            (resp) => {
                setTicketDetails(resp.data?.data);
                fetchFormData();
                resp.data?.data?.status == 22 && setNewStatus({ value: resp.data?.data.status, label: resp.data?.data.status_text })
                setLoadingDetails(false);
            },
            (error) => {
                toast.error(error, { position: toast.POSITION.TOP_CENTER });
                setLoadingDetails(false);
            }
        );
    };

    const handleClose = () => {
        history.push({ pathname: `/new_group_list` });
    };

    const SaveData = (e) => {
        e.preventDefault();
        if (!newStatus) {
            toast.error('Please select a new status', { position: toast.POSITION.TOP_CENTER });
            return;
        }

        setSaveFormSubmitting(true);
        const params = {
            master_id: selectedGroup?.master_id,
            ticket_activity_id: ticketDetails?.activity_id ,
            status: newStatus?.value || newStatus, 
        };

        HttpAPICall.withAthorization(
            'PUT',
            process.env.REACT_APP_SERVER_PATH + '/backoffice/ticket/status_update',
            access_token,
            {},
            params,
            (resp) => {
                toast.success(resp.data.msg, {
                    position: toast.POSITION.TOP_RIGHT
                });
                setSelectedTicket(null);
                setTicketDetails(null);
                setNewStatus(null);
                setStatusOptions([]);
                setSaveFormSubmitting(false);
            },
            (error) => {
                toast.error(error, { position: toast.POSITION.TOP_CENTER });
                setSaveFormSubmitting(false);
            }
        );
    };

    const handleTicketSearchChange = (selectedOption) => {

        setSelectedTicket(selectedOption);

        if (!selectedOption) {
            setTicketDetails(null);
            setNewStatus(null);
            setStatusOptions([]);
            return;
        }
            fetchTicketDetails(selectedOption?.value);
        
    };

    return (
        
        <ApplicationLayout>
            <Helmet>
                <title>Change Ticket Status</title>
            </Helmet>
            <div className="page_title row m0">
                <div className='col-6'>
                    <h3>Group: {selectedGroup?.group_name}</h3>
                </div>
                <div className='col-6'>
                    <div className="text-end mt15">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="close" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className="bg-white col-9 pl4" style={{ height: "100%" }}>
                        <section className="item_view_container pageTbl">
                            <form onSubmit={SaveData} className='py-4 mx-4'>
                                <div className="row align-items-center">
                                    <label className="col-sm-3 form-label fw-bold">Search Ticket</label>
                                    <div className="col-sm-8">
                                        <InputTicketSearch
                                            fontSize="93%"
                                            placeholder="Search by Ticket ID or Subject"
                                            changeEvent={handleTicketSearchChange}
                                            isClearable={true}
                                            master_id={selectedGroup?.master_id}
                                            value={selectedTicket}
                                            required={true}
                                        />
                                        {loadingDetails && <Loader />}
                                    </div>
                                </div>

                                {ticketDetails && (
                                    <div className="row align-items-center my-3">
                                        <div className="offset-3 col-sm-8">
                                            <TicketMiniDetail ticketDetail={[{ data: ticketDetails }]} />
                                        </div>
                                    </div>
                                )}

                                {ticketDetails  ?
                                    statusLoading ? 
                                        <Loader />
                                        :
                                        <>
                                            <div className="row mt-4 align-items-center">
                                                <label className="col-sm-3 form-label fw-bold">
                                                    Change Status To
                                                </label>

                                                <div className="col-sm-8">
                                                    <TapSelect
                                                        changeEvent={handleStatusChange}
                                                        options={statusOptions}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        required={true}
                                                        value={newStatus || ticketDetails.status_text}
                                                        placeholder="Please Select Status"
                                                        isDisabled={ticketDetails.status == 22}
                                                    />
                                                </div>
                                            </div>
                                            <div className="d-flex py-2 mx-5 align-items-end justify-content-end mt-4">
                                                <button
                                                    type="submit"
                                                    disabled={saveFormSubmitting || !ticketDetails || !newStatus || ticketDetails.status == 22}
                                                    className="btn btn-primary"
                                                >
                                                    Save
                                                    {saveFormSubmitting && (
                                                        <span className="ms-2">
                                                            <TapIcon.FontAwesomeIcon
                                                                icon={TapIcon.faSyncAlt}
                                                                className="fa-spin"
                                                            />
                                                        </span>
                                                    )}
                                                </button>
                                            </div>
                                        </>
                                    : null
                                }
                            </form>
                        </section>
                    </div>
                    <div className='col-3 pl4 pe-2 page_containt' style={{ top: "0px" }}>
                        <GroupCard groupListing={selectedGroup} />
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default ChangeTicketStatus;